import { pgTable, text, boolean, jsonb, serial } from "drizzle-orm/pg-core";
import { createInsertSchema } from "drizzle-zod";
import { z } from "zod/v4";

export const adSettingsTable = pgTable("ad_settings", {
  id: serial("id").primaryKey(),
  enabled: boolean("enabled").notNull().default(true),
  slots: jsonb("slots").notNull().default([]),
  globalScript: text("global_script").default(""),
  adsensePublisherId: text("adsense_publisher_id").default(""),
});

export const insertAdSettingsSchema = createInsertSchema(adSettingsTable).omit({ id: true });
export type InsertAdSettings = z.infer<typeof insertAdSettingsSchema>;
export type AdSettings = typeof adSettingsTable.$inferSelect;
